/**
 * Supplier-declared return terms → one display line, both shells.
 * null policy ⇒ null line (never imply terms the supplier didn't state).
 * This is the supplier's OWN policy for DIRECT deals — distinct from the
 * Aska Services return-protection guarantee.
 */
import type { SupplierReturns } from '../api/types'

export function supplierReturnsLine(r: SupplierReturns | null | undefined): string | null {
  if (!r || typeof r.accepting !== 'boolean') return null
  if (!r.accepting) return 'Returns: final sale'
  const window = r.windowDays ? ` within ${r.windowDays} days` : ''
  const note = r.note ? ` — ${r.note}` : ''
  return `Returns accepted${window}${note}`
}
